<template>
  <div v-if="!isMissingWebsite" class="description metric-colon">
    <span class="label" :id="websiteLabelId" v-html="descDisplayText"></span>
    <LinkExternalUrl v-if="hasWebsiteSlot&&isValidWebsite" :url="websiteValue" :labelId="websiteLabelId"/>
    <template v-else-if="hasWebsiteSlot">{{websiteValue}}</template>
    <template v-else>{{defaultValue}}</template>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component'

import LinkExternalUrl from '@/components/LinkExternalUrl'
import { MetadataDescMixin, MetadataWebsiteMixin } from './metadata-mixin'

// Regex to check for common 'invalid' website urls:
//  - space or comma for multiple URLs in a list
//  - @ for email addresses
const re = /[\s,@]/

@Component({
  components: {
    LinkExternalUrl
  }
})
export default class MetricDescColon extends mixins(MetadataDescMixin, MetadataWebsiteMixin) {
  /* Getters */

  get isMissingWebsite () { return this.hasWebsiteSlot && !this.hasWebsiteValue }
  get isValidWebsite () { return !re.test(this.websiteValue) }
  get websiteLabelId () {
    return this.hasWebsiteSlot ? 'metric-desc-colon-' + this._uid : undefined
  }

  // Override default template text if there is website text
  get customTemplateText () { return this.websiteDispText }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sqs/2020/tab-mods/MetricDescColon.vue